module.exports = __webpack_public_path__ + "img/charon.8ea9c582.png";